import { extendTheme } from '@chakra-ui/react'
import type { Dict } from '@chakra-ui/utils'

import { components } from './components/components'
import { config } from './config'
import {
  colors, breakpoints
} from './foundations'
import styles from './styles'

/**
 * Base theme for mathletics, based on Designs from UX team in Figma.
 *
 * @see Figma https://www.figma.com/file/AVVZO09XE8fZ0uuOaJYcQg/B2C-Onboarding---for-Dev
 */
export const theme: Dict = extendTheme({
  colors,
  config,
  styles,
  breakpoints,
  components
})
